import type { RawAnalyticsSchema } from '../types/AnalyticsSchema';

export function parseRawData(data: RawAnalyticsSchema) {
  return Object.entries(data).map(([id, details]) => ({
    id,
    ...details,
  }));
}
